import { z } from "zod";
import { RubricDimensionSchema } from "./primitives.js";
/**
 * THE SIX SKILLS, EXPLAINED (pedagogy review, 2026-09-11; decision 1's side
 * note): what each skill means, what the top and bottom of its scale look
 * like, how it is read, and how to practise it — with the research the
 * product's design leans on. GET /skills.
 *
 * A reference, not a skill surface: nothing here is about any one learner,
 * so it may cite years and paper ids. The learner-facing sentences still
 * carry no reading as a digit; the scale is described in words.
 */
export const SkillExplainedSchema = z.strictObject({
    dimension: RubricDimensionSchema,
    /** The one-line definition: what the skill trains. */
    trains: z.string().min(1),
    /** What the top of the scale looks like, in words. */
    strong: z.string().min(1),
    /** What the bottom of the scale looks like, in words. */
    low: z.string().min(1),
    /** Where the Assessor reads it from. */
    readFrom: z.string().min(1),
    /** The authored ways to practise it — the same shelf the development plan draws from. */
    practice: z.array(z.string().min(1)).min(3),
});
export const ResearchNoteSchema = z.strictObject({
    /** What the product does because of this. */
    claim: z.string().min(1),
    /** The source, named. */
    source: z.string().min(1),
    url: z.string().url(),
});
export const SkillsDoctrineSchema = z.strictObject({
    /** The thesis, in a few sentences. */
    thesis: z.array(z.string().min(1)).min(1),
    skills: z.array(SkillExplainedSchema).length(6),
    /** How a reading is taken, in a few sentences. */
    howRead: z.array(z.string().min(1)).min(1),
    research: z.array(ResearchNoteSchema).min(1),
});
//# sourceMappingURL=skills.js.map